import { useDesactivateOfferRedirect } from '@/hooks/useDesactivateOfferRedirect';
import { useHomeData } from '@/hooks/useHomeData';
import { useMetaTrackHook } from '@/hooks/useMetaTrackHook';
import { useSacola } from '@/hooks/useSacola';
import { useSnackbar } from '@/hooks/useSnackbar';
import { registrarEvento } from '@/services/googleAnalytics';
import {
  // listarCombosComProduto,
  recuperarProduto,
} from '@/services/marketplaceService';
// import { Combo } from '@/types/combo';
import { PlanoProduto, Produto } from '@/types/produto';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { usePathname } from 'next/navigation';
import { useEffect, useMemo, useRef, useState } from 'react';

function useProdutoPageHook($produtoSlug: string, router: AppRouterInstance) {
  const caminhoURL = usePathname();

  const { produtos } = useHomeData();
  const { itens, adicionarItemASacola, existeComboNaSacola } = useSacola();
  const { mostrarSnackbar } = useSnackbar();

  const [produto, setProduto] = useState<Produto | null>(null);
  const [carregandoProduto, setCarregandoProduto] = useState(false);

  const giftCardsValores: PlanoProduto[] = useMemo(() => {
    if (!produto || !produto.planos || produto.planos.length === 0) return [];
    return [...produto.planos].sort((a, b) => a.preco - b.preco);
  }, [produto]);

  // const [produtoRelacionados, setProdutoRelacionados] = useState<
  //   Produto[] | null
  // >(null);

  // const [combosComOProduto, setCombosComOProduto] = useState<Combo[] | null>(
  //   null,
  // );

  // async function recuperarProdutosRelacionados(produto: Produto) {
  //   const produtosRelacionadosFromServer = await listarProdutos({
  //     filtros: `categoria.nome.Contains("${produto?.categoria?.nome}") && somenteBeneficio == false`,
  //   });
  //   setProdutoRelacionados(
  //     produtosRelacionadosFromServer.filter(
  //       (produtoRelacionado) => produtoRelacionado.id !== produto.id,
  //     ),
  //   );
  // }

  // async function recuperarCombosComOProduto(produtoID: string) {
  //   const combosComOProdutoFromServer =
  //     await listarCombosComProduto(produtoID);
  //   setCombosComOProduto(combosComOProdutoFromServer);
  // }

  async function recuperarInfoProduto(produtoID: string) {
    try {
      setCarregandoProduto(true);
      const produtoFromServer = await recuperarProduto(produtoID);
      setProduto(produtoFromServer);
    } catch (error: unknown) {
      if (error instanceof Error) {
        mostrarSnackbar({
          color: 'error',
          highContrast: true,
          mensagem: error.message ?? '',
          size: 1,
          variant: 'solid',
        });
      }
    } finally {
      setCarregandoProduto(false);
    }
  }

  useEffect(() => {
    if (!$produtoSlug || carregandoProduto) return;

    const produtoNaHome = produtos?.find(
      (produto) => produto.slug === $produtoSlug,
    );

    if (produtoNaHome) {
      setProduto(produtoNaHome);
    } else {
      recuperarInfoProduto($produtoSlug);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [$produtoSlug]);

  const [quantidadeProduto, setQuantidadeProduto] = useState(1);
  const [planoSelecionado, setPlanoSelecionado] = useState<number>(0);

  const { recuperarQueryStringDaUrl, enviarEventosMetaTrack } =
    useMetaTrackHook();

  const jaExecutouRecuperacaoQueryStringData = useRef(false);

  useEffect(() => {
    if (jaExecutouRecuperacaoQueryStringData.current) return;
    jaExecutouRecuperacaoQueryStringData.current = true;

    recuperarQueryStringDaUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function adicionarProdutoASacola() {
    if (!produto || !giftCardsValores) return;

    registrarEvento('produto_clicou_adicionar_sacola', {
      produtoID: produto?.produtoID,
      produto: produto?.nome,
      plano: giftCardsValores[planoSelecionado]?.nome,
      planoID: giftCardsValores[planoSelecionado]?.id,
    });
    registrarEvento('add_to_cart', {
      currency: 'BRL',
      value: giftCardsValores[planoSelecionado]?.preco,
      items: [
        {
          item_id: giftCardsValores[planoSelecionado]?.id,
          item_brand: produto?.nome,
          item_name: giftCardsValores[planoSelecionado]?.nome,
          item_discount: giftCardsValores[planoSelecionado]?.desconto,
          quantity: quantidadeProduto,
        },
      ],
    });

    enviarEventosMetaTrack('add_cart');

    adicionarItemASacola({
      produto,
      opcaoSelecionadaProduto: giftCardsValores[planoSelecionado],
      quantidade: quantidadeProduto,
    });
  }

  function comprarAgora() {
    if (!produto || !giftCardsValores) return;

    registrarEvento('produto_clicou_comprar_agora', {
      produtoID: produto?.produtoID,
      produto: produto?.nome,
      plano: giftCardsValores[planoSelecionado]?.nome,
      planoID: giftCardsValores[planoSelecionado]?.id,
    });
    registrarEvento('add_to_cart', {
      currency: 'BRL',
      value: giftCardsValores[planoSelecionado]?.preco,
      items: [
        {
          item_id: giftCardsValores[planoSelecionado]?.id,
          item_brand: produto?.nome,
          item_name: giftCardsValores[planoSelecionado]?.nome,
          discount: giftCardsValores[planoSelecionado]?.desconto,
        },
      ],
    });

    enviarEventosMetaTrack('pay_now');

    adicionarItemASacola({
      produto,
      opcaoSelecionadaProduto: giftCardsValores[planoSelecionado],
      quantidade: quantidadeProduto,
    });

    if (!existeComboNaSacola(itens)) {
      router.push('/sacola', { scroll: true });
    }
  }

  function visualizarTermosProduto() {
    sessionStorage.setItem('termoHTML', produto?.termosDeUso?.toString() ?? '');
    router.push('/termos', { scroll: true });
  }

  const valorTotal = useMemo(() => {
    if (!produto || !giftCardsValores) return 0 * quantidadeProduto;

    if (produto.desconto > 0) {
      return giftCardsValores[planoSelecionado]?.preco - produto.desconto;
    }

    return giftCardsValores[planoSelecionado]?.preco * quantidadeProduto;
  }, [produto, planoSelecionado, quantidadeProduto, giftCardsValores]);

  async function resgastarCodigoAvulso(planoID: string) {
    return router.replace(`/api/recuperar-codigo-avulso/${planoID}`);
  }

  const bannerDestaqueGiftCard: string = useMemo(() => {
    if (produto?.imagensDestaque && produto?.imagensDestaque.length) {
      return produto.imagensDestaque[produto.imagensDestaque.length - 1]
        .imagemUrl;
    }

    return produto?.imagem || '';
  }, [produto]);

  useDesactivateOfferRedirect({ offer: produto ?? ({} as Produto), router });

  return {
    caminhoURL,
    carregandoProduto,
    produto,
    combosComOProduto: [],
    comprarAgora,
    // produtoRelacionados,
    quantidadeProduto,
    setQuantidadeProduto,
    planoSelecionado,
    setPlanoSelecionado,
    adicionarProdutoASacola,
    visualizarTermosProduto,
    valorTotal,
    resgastarCodigoAvulso,
    giftCardsValores,
    bannerDestaqueGiftCard,
  };
}

export type useProdutoPageHookTypeReturn = ReturnType<
  typeof useProdutoPageHook
>;

export default useProdutoPageHook;
